module.exports = __webpack_public_path__ + "img/list-icon.svg?be5813c453ba0baf523b49c429b87632";